import styled, { css } from 'styled-components';

import { Div } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

export const NoShow = styled(Div)`
  color: ${colors.sageDark};
  background: rgba(80, 124, 117, 0.05);
  border: 2px solid ${colors.sageDark};
  border-radius: 4px;
`;
 
export const HoldCreditCard = styled(Div)`
  opacity: 0.3;
  ${props =>
    props.active
    && css`
      opacity: 1;
    `}
`;
 
